<template>
	<v-autocomplete
		chips
		clearable
		deletable-chips
		filled
		dense
		multiple
		hide-details
		small-chips
		:loading="loading"
		:label="label"
		:items="items"
		:value="value"
		:disabled="disabled"
		@input="$emit('input', $event)"
		class="c-autocomplete"
	/>
</template>

<script>
	/**
	 * @module Autocomplete
	 *
	 * @vue-prop {boolean} [loading] - Display linear progress bar
	 * @vue-prop {string} label - Sets input label
	 * @vue-prop {array} items - List of items
	 * @vue-prop {array} value - The input value
	 * @vue-prop {boolean} [disabled] - Disables the input
	 */

	export default {
		name: 'Autocomplete',
		props: {
			loading: {
				type: Boolean,
			},
			label: {
				type: String,
				required: true,
			},
			items: {
				type: Array,
				required: true,
			},
			value: {
				type: Array,
				required: true,
			},
			disabled: {
				type: Boolean,
			},
		},
	};
</script>

<style lang="scss">
	.c-autocomplete {
		border-radius: 4px !important;

		/* Hide bottom border */
		& ::before {
			border: none !important;
		}

		& .v-select__slot {
			margin-bottom: 4px;
		}

		& .v-input__slot {
			background-color: white !important;
		}

		/* Size of 'remove all selected values' icon */
		& .v-icon.notranslate.v-icon--link.mdi.mdi-close.theme--light {
			font-size: 1rem;
		}

		/* Set margin on the first chip */
		& .v-chip--select:nth-of-type(1) {
			margin-top: 4px !important;
		}

		/* Set margin on every even chip */
		& .v-chip--select:nth-child(even) {
			margin-top: 4px !important;
			margin-bottom: 4px !important;
		}

		& .v-chip--select:nth-last-child(2):nth-child(odd) {
			margin-bottom: 4px;
		}
	}
</style>
